import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TimelineLog from 'Common/TimelineLog/TimelineLog';
import IconCard from 'Common/Cards/IconCard';
import { loadSubmissionActivities } from 'Actions/submission';
import { getActivityParams } from 'Utils/getActivityParams';
import { DATE_TIME_FORMAT, ROLE_ADMIN } from 'Constants';
import { aclDecorator } from 'Decorators';
import moment from 'moment';

@connect(store => ({
    loading: store.submissionActivities.loading,
    success: store.submissionActivities.success,
    error: store.submissionActivities.error,
    data: store.submissionActivities.data,
}), dispatch => ({
    loadSubmissionActivities: (id) => dispatch(loadSubmissionActivities(id)),
}))
@aclDecorator()
export default class Activities extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        loadSubmissionActivities: PropTypes.func,
        submissionId: PropTypes.any.isRequired,
        data: PropTypes.array,
        phases: PropTypes.array,
        is: PropTypes.func.isRequired,
    };

    /**
     * Component Did Mount
    */
    componentDidMount() {
        const { loadSubmissionActivities, submissionId } = this.props;
        loadSubmissionActivities(submissionId);
    }

    render () {
        const { data, is } = this.props;

        return (
            <div>
                <IconCard
                    title="Activities"
                    backButton={
                        {
                            to: '/',
                            title: 'button.to.submissions'
                        }
                    }
                    content={
                        <TimelineLog
                            stories={data.map((activity) => {
                                const {color, title, body} = getActivityParams(activity);
                                return {
                                    title: title,
                                    titleColor: color,
                                    body: body,
                                    footer:
                                        <div>
                                            <a href={is(ROLE_ADMIN) && activity.user_id ? `/users/${activity.user_id}` : null} target='_blank' >
                                                { activity.user_id ? activity.user.name : 'System action' }
                                            </a>
                                            { ': ' + moment(activity.created_at).format(DATE_TIME_FORMAT) }
                                        </div>,
                                    inverted: true
                                };
                            })}
                            classes={{timeline: 'timeline-log-wrap'}}
                        />
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/Activities.jsx